import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { RememberService } from '@app/core/services/remember.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrFindReportGet, SrReportService } from '@app/services/sr-report.service';

@Component({ selector: 'tt-sr-find-report', templateUrl: './sr-find-report.component.html', styleUrls: ['./sr-find-report.component.css'], standalone: false })
export class SrFindReportComponent implements OnInit {
    public page?: SrFindReportGet;
    public reports: Item[] = [];
    public searching = false;
    public error = '';
    private rememberTimer?: ReturnType<typeof setTimeout>;
    constructor(private readonly report: SrReportService, private readonly remember: RememberService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> {
        try { this.page = await this.report.getFindReport(); await this.search(); } catch (error) { this.showError(error); }
    }
    public async search(): Promise<void> {
        const text = this.page?.searchtext;
        // Keep the legacy whitespace/empty-search behavior: invalid searches leave existing rows intact.
        if (text !== '') this.searching = true;
        if (text == null || !text.trim()) return;
        this.reports = [];
        try { this.reports = await this.report.findReports({ searchtext: text }); }
        catch (error) { this.showError(error); }
        finally { this.searching = false; }
    }
    public onSearchChanged(value: string): void {
        if (!this.page) return;
        const previous = this.page.searchtext; this.page.searchtext = value;
        if (previous === undefined || value === previous) return;
        clearTimeout(this.rememberTimer);
        // Explicit remembering preserves the undefined-initial guard and pending writes after leaving the view.
        this.rememberTimer = setTimeout(() => {
            const text = this.page?.searchtext;
            if (text != null) void this.remember.remember('w_srfindreport.searchtext', text).catch(error => this.showError(error));
        }, 500);
    }
    public clearSearch(): void { this.onSearchChanged(''); this.reports = []; }
    public openItem({ item, event }: { item: Item; event: MouseEvent }): void {
        if (item.item_state === 'customaction') { const action = item['item_action']; if (typeof action === 'function') action(item); return; }
        if (!item.item_state || item.item_path === '') return;
        const to = ['sractivity', 'srfindreport', 'srreportmenu', 'sroperation', 'srfollowup', 'srtravelbill'].includes(item.item_state) ? `${item.item_state}-test` : item.item_state;
        const target = { to, parms: item.item_parms };
        if (event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
